import { FormConstants, RequestorFormConstants } from "./DataEntryFieldsConstants";

/**
 * Builds the client-side "current transaction" compare payload the Duplicate
 * Transaction Check popup (DuplicateTXPopup) renders alongside the server's
 * matched duplicates. Display-only - the server does the actual duplicate matching
 * (getDuplicatesAPI); this is just the local snapshot shown for comparison.
 *
 * Extracted from DataEntryDetailsRightPane.getDuplicateCompare() (AB#35095) so
 * Classic Mode and Quick Entry produce the SAME shape from the SAME redux-form
 * values without the two drifting. `values` is the DATA_ENTRY_FIELDS_FORM values
 * both modes share.
 */
export const buildDuplicateCompareTransaction = (
    values: Record<string, any>,
    transactionId: string | undefined,
    statusName?: string,
) => {
    const v = values ?? {};
    return {
        transactionID: transactionId,
        paymentStatus: "",
        resDataEntryDate: new Date(),
        receivedDate: v[FormConstants.RECEIVED_DATE],
        stdDate: null,
        releaseDate: null,
        patientFirstName: v[FormConstants.PATIENT_NAME],
        patientLastName: v[FormConstants.PATIENT_LAST_NAME],
        patientDOB: v[FormConstants.DOB],
        mrn: v[FormConstants.MRN_ID],
        empi: v[FormConstants.EMPI_NUMBER],
        caseNumber: v[FormConstants.CASE_NUMBER],
        requestorName: v[RequestorFormConstants.REQUESTOR_NAME],
        status: statusName,
        requestorAddress: {
            address1: v[RequestorFormConstants.ADDRESS],
            address2: v[RequestorFormConstants.ADDRESS2],
            city: v[RequestorFormConstants.CITY],
            state: v[RequestorFormConstants.STATE],
            zipCode: v[RequestorFormConstants.ZIP],
            phoneNumber: v[RequestorFormConstants.PHONE_NUMBER],
            faxNumber: v[RequestorFormConstants.FAX_NUMBER],
        },
        requestorEmail: v[RequestorFormConstants.EMAIL],
        phone: v[RequestorFormConstants.PHONE_NUMBER],
        requestDocument: "",
    };
};
